import React from "react";
import {
  Select,
  InputLabel,
  FormControl,
  FormGroup,
  FormControlLabel,
  MenuItem,
  Checkbox
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
  formControl: {
    margin: "1em 0",
    minWidth: "100%"
  },
  selectEmpty: {
    marginTop: theme.spacing(2)
  }
}));

const Excretions = ({ excretions, handleExcretions }) => {
  const classes = useStyles();

  return (
    <>
      <div className="formStep--wrapper">
        <h2>Ausscheidungen</h2>
        <div className="excretions--grid">
          <div>
            <h2 className="excretions--label">Urinabsatz</h2>

            <FormControl variant="outlined" className={classes.formControl}>
              <InputLabel id="urine-label">Urinabsatz</InputLabel>
              <Select
                className="select"
                autoWidth
                variant="outlined"
                name="behavior"
                labelId="urine-label"
                id="urine"
                value={excretions.urine.behavior}
                onChange={event => {
                  handleExcretions(event, "urine");
                }}
                label="Urinabsatz"
              >
                <MenuItem value={1}>Normal</MenuItem>
                <MenuItem value={2}>Weniger oder Mehr</MenuItem>
                <MenuItem value={3}>Häufiger aber nur wenig</MenuItem>
                <MenuItem value={4}>Kein</MenuItem>
              </Select>
            </FormControl>

            {excretions.urine.behavior > 1 && (
              <>
                <FormControl variant="outlined" className={classes.formControl}>
                  <InputLabel id="urineSince-label">Seit</InputLabel>
                  <Select
                    className="select"
                    autoWidth
                    variant="outlined"
                    name="since"
                    labelId="urineSince-label"
                    id="urineSince"
                    value={excretions.urine.since}
                    onChange={event => {
                      handleExcretions(event, "urine");
                    }}
                    label="Seit"
                  >
                    <MenuItem value={1}>Mehr als 6 Stunden</MenuItem>
                    <MenuItem value={2}>Mehr als 12 Stunden</MenuItem>
                    <MenuItem value={3}>Mehr als 24 Stunden</MenuItem>
                  </Select>
                </FormControl>

                <FormControl>
                  <h3>Besonderheiten</h3>
                  <FormControlLabel
                    className={classes.formLabel}
                    control={
                      <Checkbox
                        checked={excretions.urine.bloody}
                        onChange={event => {
                          handleExcretions(event, "urine");
                        }}
                        name="bloody"
                      />
                    }
                    label="Blutig"
                  />
                </FormControl>
              </>
            )}
          </div>

          <div>
            <h2 className="excretions--label">Kotabsatz</h2>
            <FormControl variant="outlined" className={classes.formControl}>
              <InputLabel id="droppings-label">Kotabsatz</InputLabel>
              <Select
                className="select"
                autoWidth
                variant="outlined"
                name="behavior"
                labelId="droppings-label"
                id="droppings"
                value={excretions.droppings.behavior}
                onChange={event => {
                  handleExcretions(event, "droppings");
                }}
                label="Kotabsatz"
              >
                <MenuItem value={1}>Normal</MenuItem>
                <MenuItem value={2}>Kein Kotabsatz</MenuItem>
                <MenuItem value={3}>breiig</MenuItem>
                <MenuItem value={4}>flüssig</MenuItem>
              </Select>
            </FormControl>
            {excretions.droppings.behavior > 1 && (
              <>
                <FormControl variant="outlined" className={classes.formControl}>
                  <InputLabel id="droppingsSince-label">Seit</InputLabel>
                  <Select
                    className="select"
                    autoWidth
                    variant="outlined"
                    name="since"
                    labelId="droppingsSince-label"
                    id="droppingsSince"
                    value={excretions.droppings.since}
                    onChange={event => {
                      handleExcretions(event, "droppings");
                    }}
                    label="Seit"
                  >
                    <MenuItem value={1}>Mehr als 12 Stunden</MenuItem>
                    <MenuItem value={2}>Mehr als 24 Stunden</MenuItem>
                    <MenuItem value={3}>Mehr als 48 Stunden</MenuItem>
                  </Select>
                </FormControl>

                <FormGroup>
                  <h3>Besonderheiten</h3>
                  <FormControlLabel
                    className={classes.formLabel}
                    control={
                      <Checkbox
                        checked={excretions.droppings.bloody}
                        onChange={event => {
                          handleExcretions(event, "droppings");
                        }}
                        name="bloody"
                      />
                    }
                    label="Blutig"
                  />

                  <FormControlLabel
                    className={classes.formLabel}
                    control={
                      <Checkbox
                        checked={excretions.droppings.black}
                        onChange={event => {
                          handleExcretions(event, "droppings");
                        }}
                        name="black"
                      />
                    }
                    label="Pechschwarz"
                  />
                </FormGroup>
              </>
            )}
          </div>

          <div>
            <h2 className="excretions--label">Erbrechen</h2>
            <FormControl variant="outlined" className={classes.formControl}>
              <InputLabel id="vomiting-label">Erbrechen</InputLabel>
              <Select
                className="select"
                autoWidth
                variant="outlined"
                name="behavior"
                labelId="vomiting-label"
                id="vomiting"
                value={excretions.vomiting.behavior}
                onChange={event => {
                  handleExcretions(event, "vomiting");
                }}
                label="Erbrechen"
              >
                <MenuItem value={1}>Normal</MenuItem>
                <MenuItem value={2}>Gelegentlich</MenuItem>
                <MenuItem value={3}>ständig</MenuItem>
                <MenuItem value={4}>behält nichts bei sich</MenuItem>
              </Select>
            </FormControl>
            {excretions.vomiting.behavior > 1 && (
              <>
                <FormControl variant="outlined" className={classes.formControl}>
                  <InputLabel id="vomitingSince-label">Seit</InputLabel>
                  <Select
                    className="select"
                    autoWidth
                    variant="outlined"
                    name="since"
                    labelId="vomitingSince-label"
                    id="vomitingSince"
                    value={excretions.vomiting.since}
                    onChange={event => {
                      handleExcretions(event, "vomiting");
                    }}
                    label="Seit"
                  >
                    <MenuItem value={1}>Mehr als 12 Stunden</MenuItem>
                    <MenuItem value={2}>Mehr als 24 Stunden</MenuItem>
                    <MenuItem value={3}>Mehr als 48 Stunden</MenuItem>
                  </Select>
                </FormControl>

                <FormGroup>
                  <h3>Besonderheiten</h3>
                  <FormControlLabel
                    className={classes.formLabel}
                    control={
                      <Checkbox
                        checked={excretions.vomiting.foamy}
                        onChange={event => {
                          handleExcretions(event, "vomiting");
                        }}
                        name="foamy"
                      />
                    }
                    label="schaumig"
                  />

                  <FormControlLabel
                    className={classes.formLabel}
                    control={
                      <Checkbox
                        checked={excretions.vomiting.bile}
                        onChange={event => {
                          handleExcretions(event, "vomiting");
                        }}
                        name="bile"
                      />
                    }
                    label="galle"
                  />

                  <FormControlLabel
                    className={classes.formLabel}
                    control={
                      <Checkbox
                        checked={excretions.vomiting.bloody}
                        onChange={event => {
                          handleExcretions(event, "vomiting");
                        }}
                        name="bloody"
                      />
                    }
                    label="blutig"
                  />
                </FormGroup>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Excretions;
